import "../lib/autocomplete/js/autocomplete";
(function (window) {
  /**
   * BatchGeoAutocomplete is a wrapper manages loading the jQuery UI
   * autocomplete library and creating the autocomplete instances. It is
   * mostly here as a wrapper to manage default settings and such.
   *
   * @example
   * // In jQuery Autocomplete you would write:
   * $('.someElement').autocomplete({...})
   *
   * // To move to BatchGeoAutocomplete
   * new BatchGeoAutoComplete({container: '.someElement', ...})
   *
   * @param {object} options An options hash that will be passed into jQuery
   * UI Autocomplete.
   * @param {jQuery|string|HTMLElement} options.container A jQuery element,
   * selector or HTMLElement to be used as the container to attach
   * autocomplete to.
   *
   * @see {@link https://api.jqueryui.com/autocomplete/} For jQuery UI Autocomplete options and settings
   *
   * @constructor
   */
  var BatchGeoAutocomplete = function (options) {
    this.settings = $.extend(
      true,
      {
        container: null,
      },
      options,
    );

    this._autocompleteSettings = _.omit(options, ["container"]);

    this.init();
  };

  /**
   * Called automatically when initializing but can be recalled if you need to
   * reattach the autocomplete at any time.
   */
  BatchGeoAutocomplete.prototype.init = function () {
    this._instance = $(this.settings.container).autocomplete(
      this._autocompleteSettings,
    );
  };

  /**
   * Will return a jQuery instance for the autocomplete library if you need
   * to access methods such as .focus() or other jQuery UI Autocomplete APIs.
   *
   * If the autocomplete library has not yet loaded this returns undefined.
   *
   * @returns {jQuery|undefined} Returns a jQuery UI Autocomplete instance
   */
  BatchGeoAutocomplete.prototype.getJqueryInstance = function () {
    return this._instance;
  };

  // This patches a long standing jQuery UI Autocomplete issue where the width
  // of the dropdown does not match the width of the input/container it is
  // attached to. This is applied directly into the prototype and applies to
  // all instances so we add it here once Autocomplete is loaded.
  jQuery.ui.autocomplete.prototype._resizeMenu = function () {
    this.menu.element.outerWidth(this.element.outerWidth());
  };

  window.BatchGeoAutocomplete = BatchGeoAutocomplete;
})(window);
